import { Button } from "primereact/button"
import { Dropdown } from "primereact/dropdown"
import { Menubar } from "primereact/menubar";
import { useNavigate } from "react-router-dom";
import { useMenu } from "./Hooks/menubarItems";

const MenuBar = ({ lang, setLang }: any) => {

    const countries = [
        { name: 'EN', code: 'GB', lang: "en" },
        { name: 'TR', code: 'TR', lang: 'tr' },
    ];

    const countryOptionTemplate = (option: any) => {
        return (
            <div className="flex align-items-center">
                <img alt={option.name} src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`} className={`mr-2 flag flag-${option.code.toLowerCase()}`} style={{ width: '18px' }} />
                <div>{option.name}</div>
            </div>
        );
    };

    const selectedCountryTemplate = () => {
        return (
            <i style={{color: "#2D3967"}} className="pi pi-globe text-2xl flex justify-content-center align-items-center"></i>
        );
    };

    const navigate = useNavigate();

    const { items } = useMenu();

    const start = (
        <div className="flex align-items-center gap-1">
            <img 
                src="/LogoWithColoredText.png" 
                className="cursor-pointer" 
                height={35} 
                alt="Mobithera Logo" 
                onClick={() => navigate("/preview")} 
            />
            <span style={{ fontSize: "1rem", color: "#727A99", marginTop: "-0.5rem" }}>™</span>
        </div>
    );


    const end = (
        <div className="flex gap-4 align-items-center">
            <Dropdown value={lang} onChange={(e) => setLang(e.value)} options={countries} optionLabel="name"
                valueTemplate={selectedCountryTemplate} itemTemplate={countryOptionTemplate}
                className='globalDropdown' />
            <Button label="Book a Demo" className="text-xl"
                style={{
                    color: "white",
                    backgroundColor: "#E3506B",
                    borderRadius: "10px",
                    fontWeight: 700,
                    height: "3rem",
                    width: "12rem"
                }} onClick={() => navigate("/request-demo")} />
        </div>
    )

    return (
        <Menubar 
            model={items} 
            start={start} 
            end={end} 
            className="w-full flex flex-wrap gap-5 justify-content-center md:justify-content-between align-items-center" 
            style={{
                border: "none",
                borderRadius: "0",
                paddingTop: "1.5rem",
                paddingLeft: "1.5rem",
                paddingRight: "1.5rem",
                zIndex: 1000
            }} 
        />
    )

}

export default MenuBar;